export default __webpack_public_path__ + "static/media/taxes.86e33f1e.png";